import { useTranslation } from 'react-i18next';
import { phaseLabelKey, type CountdownPhase } from '@/lib/task-phase';
import styles from './PhaseBadge.module.css';

/**
 * FAZ ROZETI — offer / decide / payment / passive.
 *
 * Faz, kartin hangi dugmeleri gosterecegini belirleyen TEK degisken; bu yuzden
 * kartin en ustunde adi ve rengiyle duruyor.
 *
 * KUTUSUZ (mobil karari): cerceveli pill her karti rozet yiginina ceviriyordu;
 * 6px renkli nokta + ayni renkte micro metin ayni bilgiyi daha sessiz verir.
 *
 * Renk `--color-phase-*` jetonlarindan gelir ve CSS modulundeki faz sinifi
 * uzerinden baglanir; satir ici renk yazilsaydi koyu temada donerdi.
 *
 * Metin: `t(phaseLabelKey(phase, taskStatusCode))` — dort faz anahtari ceviri dosyasinda KOK
 * SEVIYEDE duruyor cunku sunucudan gelen `countdownStatus` degeri dogrudan t()'ye giriyor.
 * (bkz. src/i18n/locales/tr.ts basindaki uyari.) Tek istisna 'payment_received' (2026-09-26):
 * faz yine 'payment' ve renk de oyle kalir, ama metin kok 'payout' anahtari ("Gonderim
 * Bekliyor") — odemesini yapmis musteriye "Odeme Bekliyor" demek yanlis olurdu.
 */

export type PhaseBadgeProps = {
  phase: CountdownPhase;
  /** Sunucudaki `taskStatusCode`. Verilmezse metin yalniz fazdan okunur. */
  taskStatusCode?: string | null | undefined;
  /**
   * Hazir metin — fazin ve durumun yerine. Talebin fazi o kartin sahibini ilgilendirmiyorsa:
   * secilmeyen buronun kartinda musterinin odeme fazi "Odeme Bekliyor" diye okunuyordu (M1).
   */
  label?: string | undefined;
};

export function PhaseBadge({ phase, taskStatusCode, label }: PhaseBadgeProps) {
  const { t } = useTranslation();

  return (
    <span className={[styles.badge, styles[phase]].join(' ')}>
      <span className={styles.dot} aria-hidden="true" />
      {label ?? t(phaseLabelKey(phase, taskStatusCode))}
    </span>
  );
}
